import { ContainerModule } from 'inversify';
import { LearningGuideController } from '../controllers/LearningGuide.controller';
import { TYPES } from './types';
import { LearningGuideService } from '../services/LearningGuide.service';
import { LearningGuideStore } from '../stores/LearningGuide.store';
import { LearningGuideMenuItemState } from '../stores/LearningGuideMenuItemState.store';
import { LearningGuideMenuItemService } from '../services/LearningGuideMenuItem.service';

export const learningGuideModule = new ContainerModule((bind) => {
  bind<LearningGuideController>(TYPES.LearningGuideController).to(LearningGuideController).inSingletonScope();
  bind<LearningGuideService>(TYPES.LearningGuideService).to(LearningGuideService).inSingletonScope();
  bind<LearningGuideMenuItemService>(TYPES.LearningGuideMenuItemService)
    .to(LearningGuideMenuItemService)
    .inSingletonScope();
  bind<LearningGuideStore>(TYPES.LearningGuideStore).to(LearningGuideStore).inSingletonScope();
  bind<LearningGuideMenuItemState>(TYPES.LearningGuideMenuItemState).to(LearningGuideMenuItemState).inSingletonScope();
});
